/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NzbnCompanyResponseListBaseResponse as ModelsCustomerNzbnCompanyResponseListBaseResponse } from '../../models/Models/Customer/nzbn-company-response-list-base-response';

export interface V3CompaniesNzbnGet$Json$Params {
  nzbn: string;
}

export function v3CompaniesNzbnGet$Json(http: HttpClient, rootUrl: string, params: V3CompaniesNzbnGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CompaniesNzbnGet$Json.PATH, 'get');
  if (params) {
    rb.path('nzbn', params.nzbn, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>;
    })
  );
}

v3CompaniesNzbnGet$Json.PATH = '/v3/companies/{nzbn}';
